/** Per-column width cap so N columns never exceed 100% of the block. */
export function maxColumnWidthPct(columns) {
  const cols = Number(columns) || 1;
  return Math.round((100 / cols) * 2) / 2;
}

/** Width preset expressed as a percentage of the current column limit. */
export function relativeColumnWidthPct(columns, ratio) {
  const safeRatio = Math.min(Math.max(Number(ratio) || 0, 0), 1);
  return Math.round(maxColumnWidthPct(columns) * safeRatio * 2) / 2;
}

export function clampColumnWidthPct(val, columns) {
  const max = maxColumnWidthPct(columns);
  const n = Number(val);
  if (!Number.isFinite(n) || n <= 0) return 0;
  return Math.min(n, max);
}

export function roleNameColumnWidthMin({
  doubleColumns,
  columns,
  blockInset,
}) {
  const hasInset = Boolean(blockInset) && blockInset !== "default";
  if (doubleColumns && Number(columns) === 2 && hasInset) return 50;

  // Preserve the existing 30% custom/preset width in one-column layouts,
  // while allowing the relative 40%-of-maximum preset (20%) in two columns.
  return Math.min(30, relativeColumnWidthPct(columns, 0.4));
}

export function clampRoleNameColumnWidthPct(val, options) {
  const min = roleNameColumnWidthMin({
    doubleColumns: options?.double_columns,
    columns: options?.columns,
    blockInset: options?.block_inset,
  });
  const max = maxColumnWidthPct(options?.columns);
  const n = Number(val);
  const safeValue = Number.isFinite(n) && n > 0 ? n : min;

  return Math.min(Math.max(safeValue, min), max);
}
